import { delay } from 'redux-saga';
import { call, put } from 'redux-saga/effects';


import { 
    getDataWithToken, 
    postDataWithToken,

    SEND_CHAT_MESSAGES_URL,
    GET_CHAT_MESSAGES_URL,
    GET_PROVIDER_SIDE_CHAT_MESSAGES_URL,
    SEND_PROVIDER_SIDE_CHAT_MESSAGES_URL
} from 'Utils/api';

import {
    TOAST_ERROR, 
    SEND_CHAT_MESSAGE_SUBMITTING,
    SEND_CHAT_MESSAGE_SUCCESS,
    GET_CHAT_MESSAGES_SUBMITTING,
    GET_CHAT_MESSAGES_SUCCESS
} from 'Constants/actionConstants';

import ChatMessage from '../models/ChatMessage';
import { getCompanyType } from 'Utils/storage';
import { PROVIDER_VALUE } from 'Constants/commonConstants';

export function* sendChatMessage(action) {
    try{
        yield put({
            type: SEND_CHAT_MESSAGE_SUBMITTING,
            newMessage: new ChatMessage({...action.params, created: new Date().getTime(), chat_id: "TMP_MSG"})
        });
        const data = yield call(postDataWithToken, (getCompanyType() === PROVIDER_VALUE) ? SEND_PROVIDER_SIDE_CHAT_MESSAGES_URL : SEND_CHAT_MESSAGES_URL, action.params);
        yield put({
            type: SEND_CHAT_MESSAGE_SUCCESS
        });
        if(action.onSuccess) {
            action.onSuccess();
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getChatMessages(action) {
    try{
        yield put({
            type: GET_CHAT_MESSAGES_SUBMITTING
        });
        const data = yield call(getDataWithToken, (getCompanyType() === PROVIDER_VALUE) ? GET_PROVIDER_SIDE_CHAT_MESSAGES_URL :  GET_CHAT_MESSAGES_URL, action.params);
        if(data.data) {
            const messages = data.data.list.map((msg) => new ChatMessage(msg));
            yield put({
                type: GET_CHAT_MESSAGES_SUCCESS,
                messages,
                previousMessages: action.previousMessages,
                count: data.data.count
            });
        }
        if(action.onSuccess) {
            action.onSuccess();
        }
    } catch(e) {
        console.log('ERROR', e);
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e);
        }
    }
}